var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",attrs:{"type":_vm.type,"title":_vm.nativeTitle,"disabled":_vm.disabled,"name":_vm.name,"value":_vm.value},on:{"click":_vm.click,"mouseover":_vm.mouseover,"mouseleave":_vm.mouseleave,"focus":_vm.focus,"blur":_vm.blur}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }